import React, { useState, useEffect } from "react";
import "./TrainingPopup.css";
import { X } from "lucide-react";

import bannerImage from "../../assets/jun.png";

const SummerTrainingPopup = () => {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!open) return null;

  return (
    <div className="popup-overlay">

      <div className="popup-container">

        <button
          className="close-btn"
          onClick={() => setOpen(false)}
        >
          <X size={22} />
        </button>

        <img
          src={bannerImage}
          alt="Summer Training Banner"
          className="popup-banner"
        />

        <div className="button-wrapper">
          <a
            href="https://forms.gle/WP8712uEqMTtwHTs5"
            target="_blank"
            rel="noopener noreferrer"
            className="apply-btn"
          >
            
          </a>
        </div>

      </div>

    </div>
  );
};

export default SummerTrainingPopup;